import { capitalize } from 'lodash';
import Link from 'next/link';

const ColorOptimisation = ({ t, options, colors, value, getFilterUrl }) => {
  return (
    <div className="ml-[3px] grid grid-cols-2 gap-8">
      {options.map(({ label: color }) => (
        <Link key={color} href={getFilterUrl(color)} shallow passHref>
          <a href="_" className="group flex items-center space-x-3">
            <span className="relative -mt-[3px] flex h-[1.125rem] w-[1.125rem] shrink-0 items-center justify-center">
              <span
                role="button"
                className={`relative h-[18px] w-[18px] shrink-0 rounded-full ${
                  color === 'WHITE' || !colors[color] ? 'border border-blue/10' : ''
                }`}
                style={{ background: colors[color] }}
                aria-label={color}
              />
              <span
                className={`absolute -z-10 h-6 w-6 shrink-0 rounded-full border border-black ${
                  value.includes(color) ? 'block' : 'hidden lg:group-hover:block'
                }`}
              />
            </span>
            <span className="text-body-1 shrink-0">
              {t(color, color.split(' ').map(capitalize).join(' '))}
            </span>
          </a>
        </Link>
      ))}
    </div>
  );
};

export default ColorOptimisation;
